import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { BREAKPOINTS } from 'utils/styled'

export const SHeroImageContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  & img,
  picture {
    width: 100%;
  }
`

export const faqTitleCss = css`
  @media ${BREAKPOINTS.MD.max} {
    text-align: start;
  }
`

export const SButton = styled(Button)`
  @media ${BREAKPOINTS.LG.max} {
    align-self: center;
  }
  @meddia ${BREAKPOINTS.MD.max} {
    width: 100%;
  }
`
